module.exports = __webpack_public_path__ + "static/media/stu_and_remmy2.ed679345.jpg";